import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.InvestmentSearchDropdownRoot),
  () => import('./InvestmentSearchDropdown'),
  (InvestmentSearchDropdown) => {
    ComponentUtil.binder(Hooks.InvestmentSearchDropdownRoot, InvestmentSearchDropdown);
  },
);
